const body = document.body;
// 依据视口宽度而不是 body 宽度来判断是否为移动端
// 这里阈值可以适配常见平板以下设备
const WIDTH = 992; // refer to Bootstrap's responsive design

export default {
    data() {
        return {
            is_mobile: false,
        }
    },
    beforeMount() {
        window.addEventListener('resize', this.$_resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.$_resizeHandler)
    },
    mounted() {
        const isMobile = this.$_isMobile();
        this.is_mobile = isMobile;
    },
    methods: {
        $_isMobile() {
            // 优先使用窗口可视宽度，兼容各类 WebView 和浏览器缩放场景
            const winWidth =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                body.getBoundingClientRect().width;
            return winWidth < WIDTH;
        },
        $_resizeHandler() {
            const isMobile = this.$_isMobile();
            this.is_mobile = isMobile;
        }
    },
}
